var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8637 11.3637H3.87981L7.6217 7.62171C8.06549 7.178 8.06549 6.45846 7.6217 6.01467C7.17799 5.57096 6.45845 5.57096 6.01466 6.01467L0.332841 11.6965C-0.110947 12.1402 -0.110947 12.8597 0.332841 13.3035L6.01466 18.9854C6.23663 19.2072 6.52739 19.3182 6.81822 19.3182C7.10905 19.3182 7.39989 19.2072 7.6217 18.9854C8.06549 18.5416 8.06549 17.8221 7.6217 17.3783L3.87981 13.6364H23.8637C24.4912 13.6364 25 13.1276 25 12.5C25 11.8725 24.4912 11.3637 23.8637 11.3637Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColapse);
export default __webpack_public_path__ + "static/media/colapse.4a7842eb35fe4d5adeaf1302434163ab.svg";
export { ForwardRef as ReactComponent };